module.exports = __webpack_public_path__ + "img/cpc.75c387c1.jpeg";